<style lang="less" rel="stylesheet/less" scoped>
    .article-list-item{
        overflow:hidden;
        padding:0 20px;
        margin-bottom:15px;
        .left{
            width:80px;
            height:80px;
            float:left;
            .avatar{
                float:left;
                width:80px;
                height:80px;
                background:#ccc;
                background-size:cover;
                background-position:center center;
            }
        }
        .right{
            margin-left:100px;
            .title{
                color:#111;
                font-weight:bold;
                font-size:15px;
                line-height:20px;
                .tag{
                    color:#fff;
                    background:#0ee81f;
                    font-weight:normal;
                    font-size:10px;
                    line-height:18px;
                    padding:2px 2px;
                    border-radius:3px;
                    margin-right:2px;
                    position:relative;
                    top:-2px;
                }
            }
            .desc{
                color:#666;
                font-size:13px;
            }
            .info{
                color:#999;
                font-size:10px;
            }
        }
    }
</style>
<template>
    <div class="article-list-item" @click="onClick">
        <div class="left">
            <div class="avatar" :style="{'background-image':`url(${item.cover_images[0]})`}"></div>
        </div>
        <div class="right">
            <div class="title"><span class="tag">{{item.type}}</span>{{item.title}}</div>
            <div class="desc">{{item.summary || item.title}}</div>
            <div class="info">{{timeDisplay(item.publish_time*1000)}}</div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import moment from 'moment';

    export default {
        props:['item'],
        data() {
            return {}
        },
        computed: {},
        methods: {
            onClick(){
                $router.go({name:'news-detail',query:{id:this.item.id}})
            },
            timeDisplay(tm){
                return moment(tm).format('YYYY-MM-DD');
            }
        },
        components: {},
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// ArticleListItem.vue?0f3f9675